import {
  ARCHIVE_FAILURE,
  ARCHIVE_REQUEST,
  ARCHIVE_RESET,
  ARCHIVE_SUCCESS,
  UNARCHIVE_FAILURE,
  UNARCHIVE_REQUEST,
  UNARCHIVE_RESET,
  UNARCHIVE_SUCCESS,
} from "../actions/archive";

const initialState = {
  state: "idle",
};

export default function archive(state = initialState, action: any) {
  switch (action.type) {
    case ARCHIVE_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case ARCHIVE_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case ARCHIVE_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case ARCHIVE_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}

export function unarchive(state = initialState, action: any) {
  switch (action.type) {
    case UNARCHIVE_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case UNARCHIVE_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case UNARCHIVE_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case UNARCHIVE_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}
